var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 297.287V362.789C512 373.414 501.812 381.102 491.594 378.164L320 329.133V400.01L377.594 443.197C381.625 446.229 384 450.979 384 456.01V496.012C384 506.418 374.219 514.043 364.125 511.512L256 480.012L147.875 511.512C137.781 514.043 128 506.418 128 496.012V456.01C128 450.979 130.375 446.229 134.406 443.197L192 400.01V329.133L20.391 378.164C10.172 381.102 0 373.414 0 362.789V297.287C0 292.162 3.609 285.943 8.062 283.381L192 178.285V96.002C192 60.658 220.656 0 256 0S320 60.658 320 96.002V178.285L503.938 283.412C508.922 286.256 512 291.568 512 297.287Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneUp);
export default __webpack_public_path__ + "static/media/plane-up.9a313e09dec53666931aba51a4e5e80a.svg";
export { ForwardRef as ReactComponent };